import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'

import { projectContext, loadingContext, unfolder } from '../lib'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

export default function NewSubCampaingModal({ isModalOpen,  closeModal }) {
  const [loading, setLoading] = useContext(loadingContext)
 

  const [error, setError] = useState({ name: "" })

 

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
 
  const onSubmit = async data => {

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: "The name cannot contain symbols and special characters." })
    }

    if (ok) {
      const dataSend = {
        name: data.name,
        id: isModalOpen?.subcampaing?.sub_campaing_id || 0
      }

      axios({
        method:  'post',
        url: `${urlValue}/studio/project/camp/sub-campaing`,
        headers: {
          user: id,
          'access-token': token,
        },
        data: dataSend,
      })
        .then(function (response) {
          closeModal()
          setLoading(false)
          window.location.href = "/";
        })
        .catch(function (error) {
          closeModal()
          setLoading(false)
        })
    }
  }

  return (
    // <Modal isOpen={isModalOpen.newSubCampaing} style={customModal} ariaHideApp={false}>
      <div className="newProject-modal newCampaing-modal">
        <h1>{  "Create New Sub-campaign"  }</h1>
        <form onSubmit={handleSubmit(onSubmit)} style={{width: '100%'}}>
          <div className="inputs" id="name">
            <div className="input tooltip">
              <span>Name:</span>
              <input placeholder='Enter the name to assign to the new sub-campaign' className='input-data' id='namescp-tp' {...register('name', { required: true })}    type="text" />
              {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿?<div className='triangulo'></div></span> */}
              <Tooltip   anchorId="namescp-tp" content={`Only these characters are accepted A-Za-z0-9-,._'¿?`} place="top" />
            </div>
          </div>

          <div className="footer">
            <div className='cont-buttons'>
              {errors.name?.type === 'required'
                ? (
                  <span style={{ color: "red" }}>All fields are required</span>
                ) : (
                  <span> </span>
                )}
              <span className='errors-msg'  >{error.name}</span>
            </div>
            <div className='cont-buttons'  style={{marginTop: 25}}>
              <div className="buttons">
                <button className="cancel btn-bottom btn-bottom-cancel" type="button" onClick={() => closeModal()}>
                  Cancel
                </button>
                <button className="create btn-bottom btn-bottom-create" type="submit">
                  { "Create"}
                </button>
              </div>

            </div>
          </div>

        </form>
      </div>
    // </Modal>
  )
}
